import { useSelector } from "react-redux";

const getColor = (value) => {
  if (value <= 0.5)  return "red"; // rouge
  if (value < 0.8)   return "orange"; // orange
  return "#22c55e";                    // vert
};

const useConfidence = (dossierId, rubrique) => {
  const data = useSelector((s) => s.formulaires.data?.[dossierId]?.[rubrique]);
  const source  = useSelector((s) => s.formulaires.data?.[dossierId]?._source);

  const getConfidence = (...path) => {
    if (source === "mongodb") return { value: null, color: null, exists: false };
    const field   = path[path.length - 1];
    const parents = path.slice(0, -1);

    let current = data;
    for (const key of parents) {
      // Si un parent intermédiaire est absent → on ne sait rien
      if (current === undefined || current === null) {
        return { value: null, color: null, exists: false };
      }
      current = current[key];
    }

    // Le sous-objet parent est absent → rien à afficher
    if (current === undefined || current === null) {
      return { value: null, color: null, exists: false };
    }

    // Le sous-objet parent EXISTE (même vide {}) mais le champ est absent
    // → le backend a traité cette rubrique, le champ n'a pas été extrait → rouge 0%
    const raw = current[`${field}_confidence`];
    const parsed = parseFloat(raw);
    const normalized = (raw === null || raw === undefined || raw === "" || isNaN(parsed)) ? 0 : parsed;

    return { value: normalized, color: getColor(normalized), exists: true };
  };

  return { getConfidence };
};

export default useConfidence;